import type { AppConfig } from '../types'
import type { Action, BookingState } from '../booking/state'
import { existingOnly } from '../booking/state'
import { track } from '../analytics'

/** 7.3 Choose patient type. Hide "New patient" when the selection is existing-only. */
export function PatientTypeStep({
  config,
  state,
  dispatch,
  onBack,
  embedded
}: {
  config: AppConfig
  state: BookingState
  dispatch: React.Dispatch<Action>
  onBack: () => void
  embedded?: boolean
}) {
  const hideNew = existingOnly(state.profile, state.subProfile)
  const heading = config.copy?.patientHeading || 'Are you a new or existing patient?'

  const choose = (status: 'new' | 'existing') => {
    track('select_patient_status', { status })
    dispatch({ type: 'SELECT_STATUS', status })
  }

  return (
    <section>
      <h1 className="step-heading">{heading}</h1>
      <p className="step-sub">{state.profile?.name}</p>

      <div className="card-grid">
        {!hideNew && (
          <button className="choice-card" onClick={() => choose('new')}>
            <span className="title">New patient</span>
            <span className="desc">First time visiting us.</span>
          </button>
        )}
        <button className="choice-card" onClick={() => choose('existing')}>
          <span className="title">Existing patient</span>
          <span className="desc">I’ve been seen here before.</span>
        </button>
      </div>

      {!embedded && (
        <div className="btn-row">
          <button className="btn btn-ghost" onClick={onBack}>
            ← Back
          </button>
        </div>
      )}
    </section>
  )
}
